import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';


export default function PatientName(props) {
  const {
    patient,
  } = props || {};
  const {
    name,
  } = patient;
  return (
    <div {...ex('PatientName', props)}>
      {T('{0} 님', name)}
    </div>
  );
}
